export default __webpack_public_path__ + "static/media/example-duckduckgo-IMG.ee85547f.jpg";